export const ADOBE_TARGET = 'AdobeTarget';
export const INNERVATE = 'Innervate';
export const MULTI_ARM_BANDIT = 'MultiArmBandit';
export const COMPONENT_CLASS = 'ComponentClass';
export const COMPONENT_SELECTOR = 'ComponentSelector';